import "./ConfirmCode.css";
import useConfirmCode from "./useConfirmCode";
import LanguageSelect from "../../LanguageSelection/LanguageSelect";
import { getTranslatedText as translate } from "../../Localization/Translation";

const ConfirmCode = () => {
  const { locale, backToSignUp, onChangeInput, checkInput } = useConfirmCode();

  return (
    <div className="SignUp-form confirm-signup-form">
      <div className="signup-form-header-language">
        <div className="SignUp-form-header">
          {translate("confirm-signup-form-header", locale)}
        </div>
        {/* Language Selection */}
        <LanguageSelect />
      </div>
      <div>
        <div className="SignUp-form-inputs Confirm-SignUp-form-inputs">
          <div className="Confirm-SignUp-form-header">
            {translate("confirm-signup-please-input-code", locale)}
          </div>
          <div className="Confirm-SignUp-form-subheader">
            {translate("confirm-signup-code-is-sent-to", locale)}
            0968820968
          </div>
          <div className="mb-3 Confirm-SignUp-form-inout-code">
            <input
              type="text"
              className="form-control"
              id="confirm-signup-code"
              onChange={onChangeInput}
              aria-describedby="confirmSignupCode"
            />
            <div className="invalid-feedback">
              {translate("confirm-code-error", locale)}
            </div>
          </div>
          <div className="Confirm-SignUp-form-subheader">
            {translate("confirm-signup-ask-if-receive-code", locale)}
            <span className="confirm-signup-re-send-code">
              {translate("confirm-signup-re-send-code", locale)}
            </span>
          </div>
          <div className="confirm-signup-buttons">
            <button
              type="submit"
              className="btn btn-primary"
              onClick={checkInput}
            >
              {translate("confirm-signup-verify-code", locale)}
            </button>
            <button
              type="submit"
              onClick={backToSignUp}
              className="btn btn-secondary"
            >
              {translate("confirm-signup-close-code", locale)}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ConfirmCode;
